import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './point-allocation-system.reducer';

export const PointAllocationSystemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pointAllocationSystemEntity = useAppSelector(state => state.pointAllocationSystem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pointAllocationSystemDetailsHeading">
          <Translate contentKey="fivePlusApp.pointAllocationSystem.detail.title">PointAllocationSystem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{pointAllocationSystemEntity.id}</dd>
          <dt>
            <span id="pointType">
              <Translate contentKey="fivePlusApp.pointAllocationSystem.pointType">Point Type</Translate>
            </span>
          </dt>
          <dd>{pointAllocationSystemEntity.pointType}</dd>
          <dt>
            <span id="userPoint">
              <Translate contentKey="fivePlusApp.pointAllocationSystem.userPoint">User Point</Translate>
            </span>
          </dt>
          <dd>{pointAllocationSystemEntity.userPoint}</dd>
        </dl>
        <Button tag={Link} to="/point-allocation-system" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/point-allocation-system/${pointAllocationSystemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PointAllocationSystemDetail;
